import Route from '@ember/routing/route'

export default class extends Route {
  buildRouteInfoMetadata() {
    return { allowUnauthorizedSubscription: true }
  }
}
